module.exports = __webpack_public_path__ + "img/TW.d05adf69.jpg";